export const formatDate = (date: Date | string): string => new Date(date).toLocaleDateString('en-US', {
  year: 'numeric',
  day: '2-digit',
  month: '2-digit',
  timeZone: 'America/New_York',
});

export const formatDisplayDate = (date: Date | string): string => {
  const formattedDate = new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',  // Full month name
    day: '2-digit',
    timeZone: 'America/New_York',
  });
  return formattedDate;
};

export const isValidDate = (date: Date): boolean => date instanceof Date && !isNaN(date.getTime());

export const parseDateQueryParameter = (value: string | null): string => {
  if (!value || !/^\d{8}$/.test(value)) {
    return new Date().toISOString(); // Fallback to today's date if no date provided or invalid format
  }

  // handle date format of MMDDYYYY
  const month = value.substring(0, 2);
  const day = value.substring(2, 4);
  const year = value.substring(4, 8);
  value = `${year}-${month}-${day}T00:00:00`; // Convert today at midnight local time for Date constructor

  let result: Date = new Date(value);

  if (!isValidDate(result)) {
    result = new Date(); // Fallback to today's date if invalid
  }
  return result.toISOString();
};

export const shortenDate = (date: Date | string): string => {
  // shorten date to YYYY-MM-DD format, remove time
  const formattedDate = new Date(date).toISOString().split('T')[0];
  return formattedDate;
};